export const appPaths = {
	default: '',
	root: '/',
	code: 'code',
	otherwise: '**',
	error: 'error',
	notFound: 'not-found',
	notAuthorized: 'not-authorized',
};

export const appFragments = {
	default: [appPaths.default],
	root: [appPaths.default, appPaths.root],
	otherwise: [appPaths.default],
	error: [appPaths.default],
	notFound: [appPaths.default],
	notAuthorized: [appPaths.default],
};
